export default __webpack_public_path__ + "static/media/eraser.1f65bba1.svg";